import AxiosInterceptor from "../../AxiosInterceptorMomthera";

// 1회기 자동사고 기록지 조회
export function getAutothinkSessionWeek1FromMomthera({pid}){
    return AxiosInterceptor({
        url: '/autothink/session/week1 (1주차)',
        method: 'get',
        params: {pid}
    })
}

// 2회기 자동사고 기록지 조회
export function getAutothinkSessionWeek2FromMomthera({pid}){
    return AxiosInterceptor({
        url: '/autothink/session/week2 (2주차)',
        method: 'get',
        params: {pid}
    })
}

// 3회기 자동사고 기록지 조회
export function getAutothinkSessionWeek3FromMomthera({pid}){
    return AxiosInterceptor({
        url: '/autothink/session/week3 (3주차)',
        method: 'get',
        params: {pid}
    })
}

// 4회기 자동사고 기록지 조회
export function getAutothinkSessionWeek4FromMomthera({pid}){
    return AxiosInterceptor({
        url: '/autothink/session/week4 (4주차)',
        method: 'get',
        params: {pid}
    })
}